import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function directTripsOnlyClicked({ selected, totalTrips }) {
    const property = {
        num_trips: totalTrips,
        selected,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_search',
        label: 'direct_trips',
        property,
    });

    amplitude.track('search_filtered', {
        filter_type: 'transfers',
        results_count_before: totalTrips,
        updated_from: selected
            ? 'include_transfers'
            : 'no_transfers',
        updated_to: selected
            ? 'no_transfers'
            : 'include_transfers',
    });
}

function includeNearbyLocationsClicked({ selected, totalTrips }) {
    const property = {
        num_trips: totalTrips,
        selected,
    };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'directions',
        label: 'nearby_locations',
        property,
    });

    amplitude.track('search_filtered', {
        filter_type: 'nearby_locations',
        results_count_before: totalTrips,
        updated_from: !selected,
        updated_to: selected,
    });
}

export default {
    directTripsOnlyClicked,
    includeNearbyLocationsClicked,
};
